import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import {Title} from './ServiceTypeModal.style';
import {Button2} from '../../styles/components/button.style';
import {defaultStyles} from '../Modal/modal.config';
import {checkOpeningTime} from '../../helpers/date.helper';
import {Wrapper} from '../Modal/modal.style';
import {SERVICE_TYPE} from '../../constants/constant';
import {FormattedMessage} from 'react-intl';

class ServiceTypeModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSetDelivery = this.handleSetDelivery.bind(this);
    this.handleSetCollection = this.handleSetCollection.bind(this);
    this.initModal = this.initModal.bind(this);
  }

  initModal() {
    return document.body;
  }

  handleCloseModal() {
    this.setState({showModal: false});
  }

  handleSetDelivery() {
    this.handleSetServiceType(SERVICE_TYPE.DELIVERY);
  }

  handleSetCollection() {
    this.handleSetServiceType(SERVICE_TYPE.COLLECTION);
  }

  handleSetServiceType(value) {
    const delivery = {serviceType: value};
    this.props.changeFormValue('checkoutForm', 'serviceType', value);
    return this.props.updateFulfillment(this.props.basketUuid, delivery)
      .catch((error) => Promise.reject(error));
  }

  render() {
    const {openingTimes, restaurantModes} = this.props;
    const openForDelivery = checkOpeningTime(openingTimes.delivery) && restaurantModes.delivery;
    const openForCollection = checkOpeningTime(openingTimes.collection) && restaurantModes.collection;

    return (
      <div>
        <Modal
          isOpen={this.state.showModal}
          style={defaultStyles}
          onRequestClose={this.handleCloseModal}
          parentSelector={this.initModal}
          contentLabel="Modal"
          shouldCloseOnOverlayClick={false}
        >
          <Wrapper>
            <Title>Choose a way for us to handle this order</Title>
            {
              openForDelivery &&
              <Button2 onClick={this.handleSetDelivery}><FormattedMessage id="basket.delivery" /></Button2>
            }
            {
              !openForDelivery && restaurantModes.futureOrders &&
              <Button2 onClick={this.handleSetDelivery}><FormattedMessage id="basket.deliveryPreorderOnly" /></Button2>
            }
            <br />
            {
              openForCollection &&
              <Button2 onClick={this.handleSetCollection}><FormattedMessage id="basket.collection" /></Button2>
            }
            {
              !openForCollection && restaurantModes.futureOrders &&
              <Button2 onClick={this.handleSetCollection}><FormattedMessage id="basket.collectionPreorderOnly" /></Button2>
            }
          </Wrapper>
        </Modal>
      </div>
    );
  }
}

ServiceTypeModal.propTypes = {
  changeFormValue: PropTypes.func.isRequired,
  updateFulfillment: PropTypes.func.isRequired,
  basketUuid: PropTypes.string.isRequired,
  restaurantModes: PropTypes.object.isRequired,
  openingTimes: PropTypes.object.isRequired
};

export default ServiceTypeModal;




// WEBPACK FOOTER //
// ./components/ServiceTypeModal/ServiceTypeModal.js